export const STATUS_OPTIONS = [
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'DRAFT',     label: 'Draft'     },
  { value: 'UNPUBLISH', label: 'Unpublish' },
];

export const LIST_SECTION_LABELS = ['Contact business', 'Career'];

export const BASE_PATH = [
  'saleContact', 'cta', 0,
  'saleContactSection', 'content', 0,
  'headerSection',
] as const;

export const BREADCRUMB_PATH = [
  'saleContact', 'cta', 0,
  'saleContactSection', 'content', 0,
  'breadCrumbSection',
] as const;